export function splitInTwo<Pattern extends string, Separator extends string>(
  string: Pattern,
  separator: Separator,
): Pattern extends `${infer First}${Separator}${infer Second}`
  ? [First, Second]
  : [string, string | undefined] {
  const [a, b] = string.split(separator);
  return <any>[a, b];
}

export function capitalize<S extends string>(
  str: S,
): S extends `${infer First}${infer Rest}` ? `${Uppercase<First>}${Rest}` : Uppercase<S> {
  return (str[0].toLocaleUpperCase() + str.substring(1)) as any;
}
